import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';

type Props = {
  images: {
    id?: string;
    src: string;
    alt?: string;
  }[];
};

const EventImageSection: React.FC<Props> = ({ images }) => {
  const navigate = useNavigate();

  const handleImageClick = (eventId?: string) => {
    if (eventId) {
      navigate(`/2025/events?event=${eventId}`);
    }
  };

  // 表示数: SPは最大5件、PCは最大9件
  const itemsSp = images.slice(0, 5);
  const itemsPc = images.slice(0, 9);

  return (
    <>
      {/* SP/Tablet レイアウト（元デザイン） */}
      <div className={styles.spLayout}>
        {itemsSp[0] && (
          <button
            type="button"
            className={styles.mainImage}
            onClick={() => handleImageClick(itemsSp[0].id)}
            aria-label={itemsSp[0].alt || 'イベント画像'}
          >
            <div className={styles.imageBg} style={{ backgroundImage: `url(${itemsSp[0].src})` }} />
            <img src={itemsSp[0].src} alt={itemsSp[0].alt || ''} className={styles.image} />
          </button>
        )}
        <div className={styles.subImages}>
          {itemsSp.slice(1).map((img, idx) => (
            <button
              key={`${img.src}-${idx}`}
              type="button"
              className={styles.subImage}
              onClick={() => handleImageClick(img.id)}
              aria-label={img.alt || 'イベント画像'}
            >
              <div className={styles.imageBg} style={{ backgroundImage: `url(${img.src})` }} />
              <img src={img.src} alt={img.alt || ''} className={styles.image} />
            </button>
          ))}
        </div>
      </div>

      {/* PC レイアウト（3カラム・最大9件） */}
      <div className={styles.pcGrid}>
        {itemsPc.map((img, idx) => (
          <button
            key={`${img.src}-${idx}`}
            type="button"
            className={styles.card}
            onClick={() => handleImageClick(img.id)}
            aria-label={img.alt || 'イベント画像'}
          >
            <div className={styles.imageBg} style={{ backgroundImage: `url(${img.src})` }} />
            <img src={img.src} alt={img.alt || ''} className={styles.image} />
          </button>
        ))}
      </div>
    </>
  );
};

export default EventImageSection;
